import type { FC } from "react";

import { Dialog, type DialogProps } from "./Dialog";
import { SquareButton } from "./buttons/SquareButton";

import { t } from "i18n/i18n";

type ConfirmationDialogProps = DialogProps & {
  cancelButtonText?: string;
  confirmButtonText?: string;
  confirmButtonKind?: "accent" | "caution";
  onConfirm?: () => void;
};

export const ConfirmationDialog: FC<ConfirmationDialogProps> = ({
  onClose,
  children,
  cancelButtonText = t("common.cancel"),
  confirmButtonText = t("common.confirm"),
  confirmButtonKind = "accent",
  onConfirm = () => {},
  ...props
}) => (
  <Dialog titleClassName="text-base font-bold" {...props} onClose={onClose}>
    <>
      {children}

      <div className="mt-8 flex justify-end gap-2">
        <SquareButton
          eventName="Confirmation modal - Cancel"
          kind="tertiary"
          size="m"
          title={cancelButtonText}
          onClick={onClose}
        >
          {cancelButtonText}
        </SquareButton>

        <SquareButton
          eventName="Confirmation modal - Confirm"
          kind={confirmButtonKind}
          size="m"
          title={confirmButtonText}
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          {confirmButtonText}
        </SquareButton>
      </div>
    </>
  </Dialog>
);
